// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2025 Mann Contractual Management Ltd

import calcHeadingLineHeights from "../../utils/calc-heading-line-heights"

const lineHeights = calcHeadingLineHeights()

export default lineHeights
